import { ParticleHero } from "@/components/ui/particle-hero";

const HeroSection = () => {
  return <ParticleHero />;
};

export default HeroSection;